import { createSlice } from "@reduxjs/toolkit";


export const guarantorInfoSlice = createSlice({
    name: "guarantorInfo",
    initialState: {
        guarantorDetails: [],
        guarantorCount: 0,
        removeGuarantorLabel: [],
        guarantorButtonTime: null,
        guarantorButtonId: null,
        minIncome: null
    },
    reducers: {
        addGuarantorButton: (state, action) => {
            const { id, minIncome } = action.payload;
            state.guarantorButtonTime = new Date().getTime();
            state.guarantorButtonId = id;
            state.minIncome = minIncome;
        },
        addGuarantor: (state, action) => {
            const existingCount = parseInt(localStorage.getItem("guarantorcount"));
            if (!Array.isArray(state.guarantorDetails)) state.guarantorDetails = [];
            const id = state.guarantorButtonId;
            state.guarantorDetails = state.guarantorDetails.filter(
                item => item && typeof item === 'object' && item.guarantorButtonId
            );
            const exists = state.guarantorDetails.some(item => item.guarantorButtonId === id);
            if (!exists) {
                state.guarantorDetails.push({
                    guarantorCount: existingCount + 1,
                    guarantorButtonId: state.guarantorButtonId,
                    minIncome: state.minIncome,
                });
                state.guarantorCount = existingCount + 1;
            } else {
            }
        },
        removeGuarantorLabel: (state, action) => {
            if (!Array.isArray(state.guarantorDetails)) state.guarantorDetails = [];
            if (!Array.isArray(state.removeGuarantorLabel)) state.removeGuarantorLabel = [];
            const existing = state.guarantorDetails
                .map((data) => data.guarantorButtonId)
                .filter(id => id !== null && id !== undefined);
            state.removeGuarantorLabel.push(...existing);
            state.removeGuarantorLabel = Array.from(new Set(state.removeGuarantorLabel));

            const idToRemove = action.payload;
            if (!state.guarantorDetails || !idToRemove) return;
            state.guarantorDetails = state.guarantorDetails.filter(
                item => item.guarantorButtonId !== idToRemove
            );
        },
        removeGuarantorLabelByModal: (state) => {
            if (!state.guarantorDetails || !state.guarantorButtonId) return;
            // Filter out the object that matches the current guarantorButtonId
            state.guarantorDetails = state.guarantorDetails.filter(
                item => item.guarantorButtonId !== state.guarantorButtonId
            );
        },
        resetGuarantorsButton: (state) => {
            state.guarantorButtonTime = null;
            state.guarantorButtonId = null;
            state.minIncome = null;
            state.guarantorCount = 0;
        },
        resetGuarantors: (state) => {
            state.guarantorDetails = [];
            state.guarantorCount = 0;
        },
    },
});
export const {
    addGuarantor,
    removeGuarantorLabel,
    resetGuarantors,
    addGuarantorButton,
    removeGuarantorLabelByModal,
    resetGuarantorsButton
} = guarantorInfoSlice.actions;

export default guarantorInfoSlice.reducer;